import type { ProductStatus } from '@repo/api-contracts';
import type { StatusTone } from '@/shared/ui';

interface StatusLabel {
  readonly label: string;
  /** 상태 배지(StatusBadge) 색 — 등록 중은 회색, 공개는 초록, 숨김은 빨강. */
  readonly tone: StatusTone;
}

/** 상품 상태의 표시 라벨·배지 색 — 목록 표가 사용한다. */
export const STATUS_LABELS: Record<ProductStatus, StatusLabel> = {
  DRAFT: { label: '등록 중', tone: 'neutral' },
  PUBLISHED: { label: '공개', tone: 'positive' },
  HIDDEN: { label: '숨김', tone: 'danger' },
};
